<div
  class="root"
  [class.wide]="wide"
  [class.larger]="larger"
  [class.santa]="santa"
  [class.slideshow]="slideshow"
  [class.sticky]="sticky"
  [style]="customStyle()"
>
  @if (mobileCloseButton) {
    <rk-mobile-close-button (click)="onAbort()"></rk-mobile-close-button>
  }
  <div class="header" *ngIf="showHeader">
    <span data-cy="modal-title" class="truncate" [innerHTML]="title"></span>
    <div class="button-container">
      <rk-icon-button
        class="hidden md:block"
        faIcon="fa-times"
        (click)="onAbort()"
        [class.hide-button]="!showCancelButon()"
      ></rk-icon-button>
    </div>
  </div>
  <div class="body text-base md:text-sm" [class]="showSubmitBlock ? 'mb-20 md:mb-0' : ''">
    <ng-content></ng-content>
  </div>
  <div class="error-wrapper" *ngIf="errorMessage">
    <mat-icon fontSet="fa" fontIcon="fa-exclamation-circle"></mat-icon>
    <span>{{ errorMessage || ('MODAL.DEFAULT.ERROR_MESSAGE' | translate) }}&#125;</span>
  </div>
  <div class="footer hidden md:flex" *ngIf="showSubmitBlock">
    @if (popover) {
      <rk-popover-trigger [popover]="popover" class="mr-auto"></rk-popover-trigger>
    }
    <rk-button
      data-cy="modal-cancel-button"
      *ngIf="showCancel && !loading"
      (click)="onCancel()"
      [btnStyle]="'flat'"
      [label]="cancelText || ('MODAL.DEFAULT.CANCEL' | translate)"
    ></rk-button>
    <rk-hotkeys-help-tooltip [disable]="isSubmitDisabled">
      <rk-button
        data-cy="modal-submit-button"
        [disabled]="loading || isSubmitDisabled"
        [loading]="loading"
        (click)="!loading ? onSubmit() : null"
        [label]="submitText || ('MODAL.DEFAULT.SUBMIT' | translate)"
      ></rk-button>
    </rk-hotkeys-help-tooltip>
  </div>
  @if (showSubmitBlock) {
    <rk-footer-actions
      (cancelled)="onCancel()"
      [cancelText]="cancelText || ('MODAL.DEFAULT.CANCEL' | translate)"
      (submitted)="!loading ? onSubmit() : null"
      [submitText]="submitText || ('MODAL.DEFAULT.SUBMIT' | translate)"
    ></rk-footer-actions>
  }
</div>
